const blockContainer = document.querySelector('.split-menu-img-block__container');

if(blockContainer) {
    const image_block = blockContainer.querySelector('.split-menu-img-block');
    const menu_entries = blockContainer.querySelectorAll('.split-menu-img-block ul li a');
    const modal = blockContainer.querySelector('.wp-block-ume-ume-accordion-holder');

    if(menu_entries && modal) {
        for(let menu_entry of menu_entries){
            menu_entry.addEventListener('click', toggleModal);
        }
    }


    function toggleModal(){
        image_block.style.display = 'none';
        modal.style.display = 'block';
    }
}



